<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template #right v-if="( $route.params.ass_id == undefined )">
                <router-link :to="{ name: 'assignments-edit', params: { ass_id: 0 } }">
                    <v-btn small rounded color="primary">Créer une fiche</v-btn>
                </router-link>
            </template>
        </PageHeader>
    
        <ItemForm v-if="( $route.params.ass_id !== undefined && parseInt( $route.params.ass_id ) >= 0 )"/>
        <v-card v-else :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
            <ItemsList />
        </v-card>
    
    </v-container>
    </template>
    
    <script>
    import PageHeader from '@/components/ui/PageHeader'
    import ItemsList  from '@/components/assignments/AssignmentList'
    import ItemForm   from '@/components/assignments/AssignmentForm'
    
    export default {
        name: 'assignments-page',
        props: ['contextStyle'],
        components: {
            PageHeader,
            ItemsList, ItemForm
        },
        data: function () {
            return {
            }
        },
        computed: { },
        created(){},
        mounted: function (){
    
        },
        methods: {
    
        },
        beforeDestroy() {
    
        },
    }
    </script>